import { BatchSelectObjectType } from 'webapp/enums/enums';

import ModelManagerTemplatesService from 'webapp/services/model-manager/templates';

export default class ModelManagerReportTemplatesService extends ModelManagerTemplatesService {
	override get objectText(): string {
		return 'Report template';
	}

	override get objectType(): BatchSelectObjectType {
		return BatchSelectObjectType.REPORT_TEMPLATE;
	}
}

declare module '@ember/service' {
	interface Registry {
		'model-manager/report-templates': ModelManagerReportTemplatesService;
	}
}
